/**
 * @desc 更新
 */
const URL = "/rantion-app-center";
import http, { updateResponse } from "@/http";
export type Response = defs.appCenter.Response;
export function request(
  body: defs.appCenter.AppDomainAggregateRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/appDomain/modify`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
